export default __webpack_public_path__ + "img/homepage-mobile-halloween.de166005.svg";